export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: `Site web`,
    introCreated: `Votre site web est déjà créé. Entrez le modifier quand vous voulez.`,
    introEmpty: `Créez le site web de votre hébergement, avec votre calendrier intégré. Vous le modifiez en glissant-déposant, sans écrire de code.`,
    emptyTitle: `Vous n'avez pas encore de site web`,
    emptyBody: `Vous choisissez un modèle du secteur, vous changez les photos et les textes, et vous avez un site web publiable. Le moteur de recherche de dates reste connecté à votre calendrier.`,
    creating: `Création…`,
    createCta: `Créer mon site web`,
    createAnother: `Créer un autre site`,
    collapse: `Replier`,
    expand: `Voir les détails`,
    limitReached: `Votre forfait autorise {n} site(s).`,
    lockedTitle: `Votre site web est inclus dans le plan Suite`,
    lockedBody: `Pour créer et gérer le site web de votre hébergement avec WACheckin, vous devez avoir le plan Suite actif.`,
    lockedCta: `Voir le plan Suite`,
    nameLabel: `Nom de votre site web`,
    viewWeb: `Voir le site web`,
    opening: `Ouverture…`,
    editCta: `Modifier ma page`,
    noPublicAddress: `Il n'a pas encore d'adresse publique`,
    published: `Publié`,
    unpublished: `Non publié`,
    visibleToPublic: `Visible pour le public`,
    addressTitle: `Adresse de votre site web`,
    addressSubtitle: `Choisissez à quelle adresse vous voulez que vos hôtes le voient.`,
    modeWacheckin: `Utilisez une adresse WACheckin`,
    modeWacheckinHint: `Gratuit et prêt tout de suite`,
    modeOwn: `Utilisez votre propre domaine`,
    modeOwnHint: `Si vous en avez déjà un`,
    subdomainLabel: `Le mot qui va devant`,
    subdomainPlaceholder: `nom-de-votre-hebergement`,
    saving: `Enregistrement…`,
    save: `Enregistrer`,
    subdomainPreview: `Votre site web sera à`,
    subdomainFree: `Écrivez-le comme vous voulez : nous le transformons en une adresse valide.`,
    otherDomainNote: `Vous avez également {dominio} connecté. Cette adresse continuera de fonctionner et mènera au même site web.`,
    noDomainYet: `Vous n'avez pas encore dit quel domaine vous voulez`,
    continueConnection: `Continuer la connexion`,
    connectDomain: `Connecter mon domaine`,
    searchTitle: `Quels hébergements le moteur de recherche peut afficher`,
    searchSubtitle: `Ceux que vous cochez ici sont ceux que vos hôtes verront en recherchant des dates.`,
    missingPhotosLabel: `Pas encore de photos :`,
    missingPhotosHelp: `Téléversez-les dans Réservations directes → Images et elles apparaîtront ici. Elles n'ont pas besoin d'être en vente.`,
    previewError: "Impossible de charger l'aperçu.",
    previewRetry: "Réessayer",
    deleteExplain: "Supprime le site et tout ce qu'il contient. Irréversible.",
    deleteTitle: "Supprimer « {nombre} » ?",
    deleteBody: "C'est irréversible. Si vous voulez seulement le masquer, désactivez « Visible par le public » et le site reste enregistré.",
    deleteItemPages: "Ses {n} pages, avec leurs textes et leur design",
    deleteItemAddress: "L'adresse où il est publié",
    deleteItemMessages: "Les messages reçus via ses formulaires",
    deleteCancel: "Annuler",
    deleteConfirm: "Oui, supprimer",
    deleting: "Suppression…",
    previewTitle: "Votre site en ce moment",
    previewDesktop: "Ordinateur",
    previewMobile: "Mobile",
    previewLoading: "Chargement de votre site…",
    previewNote: "Voici le rendu avec vos dernières modifications enregistrées. Vos voyageurs voient la dernière version publiée.",
    footerNote: `Pour l'instant, chaque compte a un site web. Écrivez-nous si vous en avez besoin de plus.`,
    deleteWeb: `Supprimer ce site web`,
    mensajes: {
      title: "Messages de votre site",
      subtitle: "Ce qu'on vous écrit dans les formulaires de votre site. Chaque message vous arrive aussi par e-mail.",
      inbox: "Boîte de réception",
      archived: "Archivés",
      unread: "{n} non lus",
      empty: "Personne ne vous a encore écrit. Quand quelqu'un remplira un formulaire de votre site, vous le verrez ici et le recevrez par e-mail.",
      emptyArchived: "Vous n'avez aucun message archivé.",
      loadError: "Impossible de charger les messages.",
      retry: "Réessayer",
      reply: "Répondre par e-mail",
      whatsapp: "WhatsApp",
      call: "Appeler",
      markRead: "Marquer comme lu",
      markUnread: "Marquer comme non lu",
      archive: "Archiver",
      unarchive: "Remettre dans la boîte",
      delete: "Supprimer",
      confirmDelete: "Supprimer ce message ? C'est irréversible.",
      confirmYes: "Oui, supprimer",
      confirmNo: "Non",
      form: "Formulaire",
      from: "Depuis",
      more: "Voir plus",
      anonymous: "Sans nom",
      replySubject: "Votre message sur {sitio}",
      notSent: "L'alerte par e-mail n'est pas encore partie.",
      errorAction: "La modification n'a pas pu être enregistrée. Réessayez.",
    },
    loadingAccommodations: `Chargement de vos hébergements…`,
    noPhotosYet: `Aucun de vos hébergements n'a encore de photos. Téléversez-les dans Réservations directes → Images et vous pourrez les afficher ici.`,
    noAccommodations: `Vous n'avez pas encore créé d'hébergements.`,
    loadError: `Impossible de charger vos pages.`,
    defaultSiteName: `Mon hébergement`,
    createError: `Impossible de créer la page.`,
    saveError: `Impossible d'enregistrer.`,
    subdomainTooLong: `C'est devenu trop long.`,
    subdomainReserved: `Ce mot est réservé. Essayez-en un autre.`,
    addressSaved: `Adresse enregistrée.`,
    subdomainChecking: `Vérification de la disponibilité…`,
    subdomainAvailable: `Elle est libre. Votre site web sera à`,
    subdomainChangeWarning: `Une fois enregistrée, l'adresse actuelle ne fonctionnera plus.`,
    subdomainTaken: `Un autre site web utilise déjà cette adresse.`,
    subdomainTryThis: `Celle-ci est libre :`,
    subdomainUse: `Utiliser celle-ci`,
    subdomainGeneric: `Elle ne dit rien de votre hébergement. Nous vous proposons :`,
    subdomainProposal: `Nous vous en proposons une avec le nom de votre hébergement :`,
    domainHelpEmpty: `Nous vous guidons pas à pas : vous saisissez le domaine, vous copiez deux lignes dans le panneau où vous l'avez acheté et nous le vérifions.`,
    domainHelpPending: `Il manque les enregistrements dans le panneau de votre domaine, ou ils ne sont pas encore parvenus partout. Entrez et nous le vérifions.`,
    popupBlocked: `Autorisez les fenêtres pop-up pour ouvrir l'éditeur.`,
    editorError: `Impossible d'ouvrir l'éditeur.`,
    confirmDelete: `Supprimer « {nombre} » ? Le site web cessera d'être visible.`,
    deleteError: `Impossible de supprimer.`,
  },

  selectOta: {
    lockBadge: `Fonctionnalité d'abonnement`,
    lockTitle: `Connectez vos OTA avec un forfait actif`,
    lockText: `Pour synchroniser <b>Booking, Airbnb, Vrbo, Expedia</b> et d'autres canaux avec WA&nbsp;Checkin, vous devez être abonné à un forfait. Avec votre abonnement, Janet synchronise les prix, la disponibilité et les réservations automatiquement — sans surréservation et sans tâches manuelles.`,
    morePreviewTitle: `et plus de 100 OTA`,
    otasAvailable: `OTA disponibles`,
    lockCta: `Voir les forfaits et m'abonner`,
    lockFoot: `Synchronisation automatique · Anti-surréservation · Assistance à la connexion incluse`,
    connectOtaTitle: `Connecter une OTA`,
    googleFaltan: "Il manque 1 élément à votre fiche pour Google | Il manque {count} éléments à votre fiche pour Google",
    googlePreparar: "La préparer",
    beta: `Beta`,
    pctChipTitle: `Pourcentage de tarif dérivé pour cette OTA`,
    comingSoon: `Bientôt disponible`,
    manage: `Gérer`,
    connectNow: `Connecter maintenant`,
    pctModalTitle: `Pourcentage de tarif`,
    pctModalHint: `Quel pourcentage en plus (ou en moins) allez-vous facturer à vos hôtes s'ils réservent via <b>{ota}</b> ? Utilisez <b>+</b> pour facturer plus ou <b>−</b> pour facturer moins (ex. : <b>15.5</b> ou <b>−10</b>).`,
    thisOta: `cette OTA`,
    cancel: `Annuler`,
    saving: `Enregistrement…`,
    save: `Enregistrer`,
    exploreMore: `Explorer plus de 100 OTA disponibles`,
    activeConnections: `Connexions actives`,
    searchPlaceholder: `Rechercher...`,
    loadingConnections: `Chargement des connexions...`,
    thChannel: `CANAL`,
    thConnectionId: `ID DE CONNEXION`,
    thLastSync: `DERNIÈRE SYNCHRONISATION`,
    thActions: `ACTIONS`,
    copied: `Copié !`,
    copyId: `Copier l'ID`,
    contactTitle: `Connectez-vous avec {name}`,
    contactDescription: `Connectez facilement votre compte {name} à notre plateforme pour accélérer votre expérience. Suivez les étapes ci-dessous pour terminer le processus.`,
    step1Title: `Créez un compte {name}`,
    step1Description: `Si vous n'avez pas encore de compte {name}, vous devrez d'abord en créer un.`,
    createAccountLink: `Créer un compte →`,
    step1Hint: `Vous avez déjà un compte ? Passez à l'étape 2.`,
    step2Title: `Contacter l'équipe d'assistance`,
    step2Description: `Une fois votre compte {name} prêt, notre équipe vous aidera à le connecter.`,
    contactSupportLink: `Contacter l'équipe d'assistance →`,
    connectDirectNoSupport: `Connecter directement (sans assistance) →`,
    step2Hint: `Recommandé uniquement si vous savez ce que vous allez configurer dans Channex.`,
    connectDirectly: `Connecter directement`,
    iframeTitle: `Connecter avec {channel}`,
    iframeSubtitle: `Connexion sécurisée gérée par le channel manager`,
    close: `Fermer`,
    iframeLoading: `Ouverture de la connexion sécurisée…`,
    actionRequired: `Action requise`,
    viewPlans: `Voir les forfaits`,
    descBooking: `Atteignez les voyageurs d'affaires et de loisirs du monde entier`,
    descAirbnb: `Connectez votre propriété à des millions de voyageurs sur Airbnb`,
    descVrbo: `Spécialisé dans les locations de vacances pour les familles`,
    descExpedia: `Réseau de voyage mondial avec des millions d'utilisateurs actifs`,
    descBnb: `Portail italien de B&B et d'hébergements de charme`,
    descGvr: `Apparaissez gratuitement dans les résultats de Google Maps et les recherches`,
    descAgoda: `Touchez des voyageurs d'Asie et du monde entier`,
    descHotelbeds: "Des lits pour les agences et voyagistes du monde entier",
    savePercentError: `Impossible d'enregistrer le pourcentage. Veuillez réessayer.`,
    channelGeneric: `Canal`,
    statusInactive: `Inactif`,
    statusConnected: `Connecté`,
    statusSyncing: `Synchronisation`,
    webReservationsName: `Réservations directes via le web`,
  },

  connectionChannel: {
    errorTitle: `Erreur`,
    successTitle: `Succès`,
    connectionDisabled: `La connexion est désactivée`,
    syncError: `Erreur lors de la synchronisation`,
    loadPropertiesError: `Erreur lors du chargement des propriétés`,
    connectionUpdated: `Connexion mise à jour {channelName}`,
    updateConnError: `Erreur lors de la mise à jour de la connexion : {detail}`,
    unknownError: `Erreur inconnue`,
    connectionWith: `Connexion avec {channelName} {status}`,
    stateUpdatedTitle: `État mis à jour`,
    confirmDeleteMessage: `Êtes-vous sûr de vouloir supprimer cette connexion ? Cela supprimera également les propriétés et les réservations associées.`,
    confirmDeleteHeader: `Confirmer la suppression`,
    deleteConnection: `Supprimer la connexion`,
    no: `Non`,
    connectionDeleted: `Connexion supprimée avec succès`,
    deleteConnError: `Erreur lors de la suppression de la connexion : {detail}`,
    webhookCopied: `Webhook copié dans le presse-papiers`,
    webhookCopyError: `Erreur lors de la copie du webhook`,
    title: `Canal de connexion (PMS)`,
    description: `Dans cette section, vous pourrez vous connecter à des systèmes de gestion immobilière (PMS) pour effectuer des consultations, la gestion et la mise à jour des informations de manière efficace et sans erreurs.`,
    connectedAccount: `Compte connecté`,
    switchTooltip: `Arrêter ou activer le service qui reçoit automatiquement les réservations dans le système.`,
    syncing: `Synchronisation...`,
    sync: `Synchroniser`,
    deleting: `Suppression...`,
    webhookLabel: `WEBHOOK :`,
    webhookInfoTooltip: `Ajoutez ce Webhook à votre compte Smoobu pour recevoir automatiquement les réservations créées dans votre PMS`,
    copyToClipboard: `Copier dans le presse-papiers`,
    syncedProperties: `Propriétés synchronisées`,
    noAddress: `Sans adresse`,
    noSyncedProperties: `Il n'y a pas de propriétés synchronisées`,
  },

  wabaIntegration: {
    activationInProgress: `Activation en cours`,
    pendingBody: `Nous activons le WhatsApp de votre entreprise. Pendant que Meta approuve vos modèles (cela prend généralement jusqu'à 24&nbsp;h) et vérifie votre numéro, vos messages sont envoyés avec le <strong>WhatsApp de WACheckin</strong> pour que vous ne cessiez pas de communiquer avec vos hôtes. Il basculera vers votre propre numéro <strong>automatiquement</strong> dès qu'il sera prêt — vous n'avez rien à faire.`,
    phoneStatusHeading: `État du numéro WhatsApp`,
    numberLabel: `Numéro :`,
    virtualNumberNote: `Il s'agit d'un <strong>numéro virtuel fourni par Meta</strong>. Il ne reçoit pas d'appels ni de SMS normaux, uniquement des messages WhatsApp via l'API.`,
    statusLabel: `État :`,
    templatesStatusHeading: `État des modèles`,
    canSend: `Votre numéro est <strong>connecté et vérifié</strong> et vous avez au moins un modèle approuvé. Vous pouvez désormais envoyer des messages.`,
    cannotSendYet: `Vous <strong>ne pouvez pas encore envoyer de messages</strong>. Attendez que Meta approuve le numéro de téléphone et les modèles.`,
    virtualPendingNote: `Gardez à l'esprit que, si votre entreprise sur Meta n'est pas vérifiée, les numéros virtuels peuvent rester à l'état <strong>en attente</strong> et ne pas permettre l'envoi.`,
    statusConnectedVerified: `Connecté et vérifié`,
    statusConnectedPending: `Connecté, en attente de vérification`,
    statusPendingApproval: `En attente d'approbation`,
    statusDisconnected: `Déconnecté`,
    statusUnknown: `Inconnu`,
  },
};
